<div class="icon">
  <svg width="76" height="75" viewBox="0 0 76 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.97638 34.6614C5.25407 16.7389 21.8438 14.0037 37.6529 4.2847C40.0807 2.79197 42.0648 1.18651 43.9485 0.598777C47.7397 -0.584686 50.1221 0.76774 53.8284 1.48368C58.2845 2.34554 64.8411 4.9548 68.5086 7.89379C70.3484 9.36804 72.4997 14.6076 73.2463 16.8786C74.5057 20.7068 75.4505 25.1338 75.6577 29.1713C75.9686 35.2462 75.429 41.3859 72.5895 46.7829C68.799 53.9851 65.5918 61.7886 59.5026 67.3545C53.4601 72.8766 48.5611 75.5062 40.3949 74.373C33.6824 73.4411 27.3944 70.3757 21.603 66.943C11.4208 60.9083 -2.27492 48.2844 0.97638 34.6614Z"
    />
  </svg>
  <i [ngClass]="icon"></i>
</div>
